module.exports = __webpack_public_path__ + "static/media/马房地图.218f818a.svg";